import { render, staticRenderFns } from "./SearchCustomerDlg.vue?vue&type=template&id=f320a500&scoped=true&"
import script from "./SearchCustomerDlg.vue?vue&type=script&lang=js&"
export * from "./SearchCustomerDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f320a500",
  null
  
)

export default component.exports